import React from 'react';
import SvgIcon from './SvgIcon';
import { SvgIconProps } from './types';

const LogOutIcon = (props: SvgIconProps) => (
    <SvgIcon {...props}>
        <g
            id="baseline-get_app-24px"
            transform="translate(12.000000, 12.000000) rotate(-270.000000) translate(-12.000000, -12.000000)"
        >
            <polygon
                id="Path"
                points="-1.13686838e-13 0 24 0 24 24 -1.13686838e-13 24"
                fill="none"
            />
            <path
                d="M19,14 L15,14 L15,8 L9,8 L9,14 L5,14 L12,21 L19,14 Z M5,3 L5,5 L19,5 L19,3 L5,3 Z"
                id="Shape"
                fillRule="nonzero"
            />
        </g>
    </SvgIcon>
);

export default LogOutIcon;
